import React from "react";

import type { CallDto } from "~/data/call/call.dto";

export const CallContext = React.createContext<CallDto | null>(null);
